module.exports = __webpack_public_path__ + "newstatic/media/3.75da77b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/3.mp4
// module id = yAUI
// module chunks = 1